/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import {
  createListenerMiddleware,
  isRejectedWithValue,
} from "@reduxjs/toolkit";
import { isConnectionError } from "helpers";
import { recordConnectionError } from "../slices/connectionSlice";

const EXCLUDED_ENDPOINTS = ["getTenantMetadata"];

export const connectionMiddleware = createListenerMiddleware();

connectionMiddleware.startListening({
  matcher: isRejectedWithValue,
  effect: (action, { dispatch }) => {
    const endpointName = (action.meta?.arg as { endpointName?: string })
      ?.endpointName;
    if (endpointName && EXCLUDED_ENDPOINTS.includes(endpointName)) {
      return;
    }

    if (isConnectionError(action.payload)) {
      dispatch(
        recordConnectionError({
          timestamp: Date.now(),
        })
      );
    }
  },
});
